import { useState } from "react";
import { Upload, Modal } from "antd";

const UiUpload = ({
    children,
    accept,
    action,
    beforeUpload,
    customRequest,
    disabled,
    fileList,
    listType,
    maxCount,
    multiple,
    name,
    onChange,
    onPreview,
    onRemove,
    showUploadList,
    ...rest
}) => {
    const [previewState, setPreviewState] = useState({
        previewOpen: false,
        previewImage: '',
        previewTitle: '',
    });

    const { previewOpen, previewImage, previewTitle } = previewState;

    const getBase64 = (file) =>
        new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.readAsDataURL(file);
            reader.onload = () => resolve(reader.result);
            reader.onerror = (error) => reject(error);
        });
    const handlePreview = async (file) => {
        if (onPreview) {
            onPreview(file);
            return;
        }
        if (!file?.url && !file?.preview) {
            file.preview = await getBase64(file?.originFileObj);
        }
        setPreviewState({
            previewImage: file?.url || file?.preview,
            previewOpen: true,
            previewTitle: file?.name || file?.url.substring(file?.url?.lastIndexOf('/') + 1),
        });
    };
    const handleCancel = () => setPreviewState((prev) => ({ ...prev, previewOpen: false }));

    return (
        <>
            <Upload
                accept={accept}
                action={action}
                beforeUpload={beforeUpload}
                customRequest={customRequest}
                disabled={disabled}
                fileList={fileList}
                listType={listType}
                maxCount={maxCount}
                multiple={multiple}
                name={name}
                onChange={onChange}
                onPreview={handlePreview}
                onRemove={onRemove}
                showUploadList={showUploadList}
                {...rest}
            >
                {children}
            </Upload>
            <Modal open={previewOpen} title={previewTitle} footer={null} onCancel={handleCancel}>
                <img alt="example" style={{ width: '100%' }} src={previewImage} />
            </Modal>
        </>
    );
};

export default UiUpload;
